import React, { lazy } from 'react'
import { Navigate } from 'react-router-dom'
import ComponentLoader from './component-loader'

const SetupWizard = ComponentLoader(lazy(() => import('../layouts/setup')))

const SetupRoutes = [
  { path: 'setup', element: <SetupWizard /> },
  { path: 'setup/:step', element: <SetupWizard /> },
  { path: '*', element: <Navigate to={'setup'} replace /> },
]

export default SetupRoutes
